(function (){
    'use strict';

    angular
        .module('services')
        .service('ManagePartnersService', ManagePartnersService);

    ManagePartnersService.$inject = ['$http', 'API_BASE'];

    function ManagePartnersService($http, API_BASE) {

        var service = this;

        service.get                 = get;
        service.getAll              = getAll;
        service.getByFilter         = getByFilter;
        service.getByFilterPartner  = getByFilterPartner;
        service.deletePartnerUser   = deletePartnerUser;
        service.updatePartnerUser   = updatePartnerUser;
        service.storePartnerUser    = storePartnerUser;

        service.store               = store;
        service.update              = update;
        service.destroy             = destroy;
        service.statistics          = statistics;
        service.sendPassword        = sendPassword;

        service.getAdmPartnerUsers = getAdmPartnerUsers;

        function get(id) {
            return $http.get(API_BASE + '/partners/' + id);
        }


        function getAll() {
            return $http.get(API_BASE + '/partners');
        }


        function getByFilter(filters) {
            return $http.post(API_BASE + '/partners/filter', filters);
        }

        function getByFilterPartner(filters) {
            return $http.post(API_BASE + '/partners/filter/partner', filters);
        }

        function store(data) {
            return $http.post(API_BASE + '/partners', data)
                .then(function(response) {
                    return response.data;
                });
        }


        function update(partner_id, data) {
            return $http.put(API_BASE + '/partners/'+partner_id, data)
                .then(function(response) {
                    return response.data;
                });
        }


        function destroy(partner_id) {
            return $http.delete(API_BASE + '/partners/'+partner_id);
        }

        function statistics(query) {
            return $http.get(API_BASE + '/partners/statistics', {params: query});
        }

        function getAdmPartnerUsers(query) {
            return $http.get(API_BASE + '/admPartners/users', {params: query});
        }

        function storePartnerUser(data) {
            return $http.post(API_BASE + '/admPartners/users', data)
                .then(function(response) {
                    return response.data;
                });
        }

        function deletePartnerUser(partner_id) {
            return $http.delete(API_BASE + '/admPartners/users/'+partner_id);
        }

        function updatePartnerUser(partner_id, data) {
            return $http.put(API_BASE + '/admPartners/users/'+partner_id, data)
                .then(function(response) {
                    return response.data;
                });
        }

        function sendPassword(partner_id) {
            return $http.post(API_BASE + '/admPartners/'+partner_id+'/send-password');
        }

    }
})();